<template>
  <div class="content__column content__column--small" v-if="user">
    <h1 class="content__title">Editar Usuario</h1>
    <form class="form" @submit.prevent="saveUser">
      <div class="fom__fieldset">
        <div class="form__container">
          <label for="first_name" class="form__label form__label--required">Nombre</label>
          <input type="text" class="form__input" name="first_name" id="first_name" v-model="user.first_name" v-validate="validation.first_name">
          <span v-show="errors.has('first_name')" class="form__alert" v-text="errors.first('first_name')"></span>
        </div>
        <div class="form__container">
          <label for="middle_name" class="form__label">Segundo Nombre</label>
          <input type="text" class="form__input" name="middle_name" id="middle_name" v-model="user.middle_name" v-validate="validation.middle_name">
          <span v-show="errors.has('middle_name')" class="form__alert" v-text="errors.first('middle_name')"></span>
        </div>
        <div class="form__container">
          <label for="last_name" class="form__label form__label--required">Apellido</label>
          <input type="text" class="form__input" name="last_name" id="last_name" v-model="user.last_name" v-validate="validation.last_name">
          <span v-show="errors.has('last_name')" class="form__alert" v-text="errors.first('last_name')"></span>
        </div>
        <div class="form__container">
          <label for="second_last_name" class="form__label">Segundo Apellido</label>
          <input type="text" class="form__input" name="second_last_name" id="second_last_name" v-model="user.second_last_name" v-validate="validation.second_last_name">
          <span v-show="errors.has('second_last_name')" class="form__alert" v-text="errors.first('second_last_name')"></span>
        </div>
        <div class="form__container">
          <label for="email" class="form__label form__label--required">Correo electrónico</label>
          <input type="email" class="form__input" name="email" id="email" v-model="user.email" v-validate="validation.email">
          <span v-show="errors.has('email')" class="form__alert" v-text="errors.first('email')"></span>
        </div>
        <div class="form__container">
          <label for="is_email_verified" class="form__label">¿Correo verificado?</label>
          <div class="form__radio-container">
            <input type="radio" class="form__radio" name="email_verified" id="si" :value="1" v-model="user.email_verified">
            <label for="si" class="form__label">
              <span class="form__selector form__selector--circular"></span> Si
            </label>
          </div>
          <div class="form__radio-container">
            <input type="radio" class="form__radio" name="email_verified" id="no" :value="null" v-model="user.email_verified">
            <label for="no" class="form__label">
              <span class="form__selector form__selector--circular"></span> No
            </label>
          </div>
          <span v-show="errors.has('email_verified')" class="form__alert" v-text="errors.first('email_verified')"></span>
        </div>
        <div class="form__container">
          <label for="phone" class="form__label">Teléfono</label>
          <input type="text" class="form__input" name="phone" id="phone" v-model="user.phone" v-validate="validation.phone">
          <span v-show="errors.has('phone')" class="form__alert" v-text="errors.first('phone')"></span>
        </div>
        <div class="form__container">
          <label for="is_phone_verified" class="form__label">Teléfono verificado?</label>
          <div class="form__radio-container">
            <input type="radio" class="form__radio" name="phone_verified" id="phone_yes_verified" :value="1" v-model="user.phone_verified">
            <label for="phone_yes_verified" class="form__label">
              <span class="form__selector form__selector--circular"></span> Si
            </label>
          </div>
          <div class="form__radio-container">
            <input type="radio" class="form__radio" name="phone_verified" id="phone_no_verified" :value="null" v-model="user.phone_verified">
            <label for="phone_no_verified" class="form__label">
              <span class="form__selector form__selector--circular"></span> No
            </label>
          </div>
          <span v-show="errors.has('phone_verified')" class="form__alert" v-text="errors.first('phone_verified')"></span>
        </div>
        <div class="form__container">
          <label for="password" class="form__label" :class="{'form__label--required': !this.user.id}">Contraseña</label>
          <input type="password" class="form__input" ref="password" name="password" id="password" v-model="user.password" v-validate="validation.password">
          <span v-show="errors.has('password')" class="form__alert" v-text="errors.first('password')"></span>
        </div>
        <div class="form__container">
          <label for="confirm_password" class="form__label" :class="{'form__label--required': !this.user.id}">Repetir Contraseña</label>
          <input type="password" class="form__input" name="confirm_password" id="confirm_password" v-model="user.confirm_password" v-validate="validation.confirm_password">
          <span v-show="errors.has('confirm_password')" class="form__alert" v-text="errors.first('confirm_password')"></span>
        </div>
        <div class="form__container" v-if="roles">
          <label class="form__label form__label--required" for="role_id">Rol de usuario</label>
          <div class="form__select-container">
            <select name="role_id" id="role_id" class="form__select" v-validate="validation.role_id" v-model="user.role_id">
              <option hidden :value="null">Elija un rol de usuario</option>
              <option v-for="(rol, index) in roles" :key="index" :value="rol.id" v-text="rol.name"></option>
            </select>
          </div>
          <span v-show="errors.has('role_id')" class="form__alert" v-text="errors.first('role_id')"></span>
        </div>
        <div class="form__container">
          <label class="form__label form__label--required" for="status_id"> Estatus de usuario</label>
          <div class="form__select-container">
            <select name="status_id" id="status_id" class="form__select" v-validate="validation.status_id" v-model="user.status_id">
              <option hidden :value="null">Elija un estatus de usuario</option>
              <option v-for="(status, index) in statusList" :key="index" :value="status.id" v-text="status.name"></option>
            </select>
          </div>
          <span v-show="errors.has('status_id')" class="form__alert" v-text="errors.first('status_id')"></span>
        </div>
        <div class="form__container">
          <div class="form__image">
            <label class="form__label" for="status_id">Foto</label>
            <img :src="photo" alt="User Photo" class="form__thumb">
            <button class="btn btn__action btn--small" @click.prevent="showMedia = true">Cargar Foto</button>
            <button v-if="user.photo" class="btn btn__transparent btn--small" @click.prevent="photo = null">Quitar Foto</button>
          </div>
        </div>
      </div>
      <input type="submit" class="btn btn__action btn--regular" value="Guardar">
      <button @click.prevent="$parent.$emit('new')" class="btn btn__transparent btn--regular">Agregar nuevo Usuario</button>
    </form>
    <media-popup @close="showMedia = false" v-if="showMedia" field="photo"></media-popup>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import mediaPopup from '@/components/media/popup'
import {config} from '@/core/config/base'
export default {
  props: {
    user: {
      type: Object,
      required: false,
      default: function () {
        return {
          first_name: null,
          middle_name: null,
          last_name: null,
          second_last_name: null,
          email: null,
          photo: null,
          phone: null,
          role_id: null,
          status_id: null,
          facebook_id: null,
          email_verified: undefined,
          phone_verified: undefined,
          password: null
        }
      }
    }
  },
  mixins: [
    httpService
  ],
  components: {
    mediaPopup
  },
  data: function () {
    return {
      newImage: false,
      showMedia: false,
      statusList: [
        {
          id: 1,
          name: 'Activo'
        },
        {
          id: 2,
          name: 'Inactivo'
        },
        {
          id: 3,
          name: 'Pendiente validación'
        }
      ],
      roles: null,
      validation: {
        first_name: 'required|max:50',
        last_name: 'required|max:50',
        middle_name: 'max:50',
        second_last_name: 'max:50',
        email: 'required|email',
        phone: 'min:8',
        password: 'min:6',
        confirm_password: 'min:6|confirmed:password',
        role_id: 'required|numeric|min_value:1|max:11',
        status_id: 'required|numeric|min_value:1|max:2',
        phone_verified: 'numeric|max_value:1',
        email_verified: 'numeric|max_value:1',
        facebook_id: 'numeric|min:8'
      }
    }
  },
  created: function () {
    this.getRoles()
  },
  mounted: function () {
    this.$on('photo', media => {
      this.photo = media.image
    })
  },
  methods: {
    saveUser: function () {
      this.$validator.validateAll()
        .then(
          result => {
            if (result) {
              let httpRequest = {
                params: '',
                module: 'users',
                element: this.user
              }
              let action
              if (this.user.id) {
                action = this.put(this.user.id, httpRequest)
              } else {
                action = this.post(httpRequest)
              }
              action.then(
                response => {
                  if (!this.user.id) {
                    this.user.id = response.data.current_id
                  }
                  this.$store.commit('notificate', {
                    title: 'USUARIO GUARDADO',
                    text: 'El usuario ha sido guardado correctamente',
                    type: 'success'
                  })
                }
              ).catch(
                () => {
                  this.$store.commit('notificate', {
                    title: 'USUARIO NO GUARDADO',
                    text: 'El usuario no ha sido guardado, por favor, intente más tarde',
                    type: 'error'
                  })
                }
              )
            }
          }
        )
    },
    getRoles: function () {
      let httpRequest = {
        params: '',
        module: 'roles'
      }
      this.get(httpRequest)
        .then(
          roles => {
            this.roles = roles.data
          }
        )
    }
  },
  computed: {
    photo: {
      get: function () {
        if (this.user.photo) {
          let image = undefined
          if (this.newImage) {
            image = this.user.photo
          } else {
            image = JSON.parse(this.user.photo)
          }
          return config.statics.url + image.sizes.small
        } else {
         return config.statics.dummy
        }
      }, set: function (value) {
        this.newImage = true
        this.user.photo = value
      }
    }
  }
}
</script>

<style lang="sass">
  @import "../../assets/sass/components/_forms"
</style>


// WEBPACK FOOTER //
// src/components/users/edit.vue